import React, { useContext, useEffect, useState, useRef } from "react";
import Context from "../../context/context";
import { fetchTermsValue, fetchTrainsTermsValue } from "../../apiCall";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

function TermsCard() {
  const containerRef = useRef(null);
  const { state, dispatch } = useContext(Context);

  const setApproveConditionDispatch = (data) =>
    dispatch({ type: "SET_APROVE_CONDITION", payload: data });
  const setIsDialogOpenDispatch = (data) =>
    dispatch({ type: "SET_IS_DAILOG_OPEN", payload: data });

  const [regularTermsValue, setRegularTermsValue] = useState("");
  const [trainsTermsValue, setTrainsTermsValue] = useState("");
  const [termsValue, setTermsValue] = useState("");

  useEffect(() => {
    fetchTermsValue((response) => {
      if (response && response.data) {
        setRegularTermsValue(response.data.termsOfUse);
      }
    });

    fetchTrainsTermsValue((response) => {
      if (response && response.data) {
        setTrainsTermsValue(response.data.trainsTerms);
      }
    });
  }, []);

  useEffect(() => {
    if (state.tripType === "רכבת") {
      setTermsValue(trainsTermsValue);
    } else {
      setTermsValue(regularTermsValue);
    }
  }, [state.tripType, regularTermsValue, trainsTermsValue]);

  // --- אישור ---
  const handleOK = () => {
    setApproveConditionDispatch(true);
    setIsDialogOpenDispatch(false);
  };

  const handleDownloadPDF = async () => {
    try {
      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const root = containerRef.current;
      if (!root) return;

      const sections =
        root.querySelectorAll(".newPage")?.length > 0
          ? root.querySelectorAll(".newPage")
          : [root];

      for (let i = 0; i < sections.length; i++) {
        const section = sections[i] ;

        const originalWidth = section.style.width;
        section.style.width = "900px";

        const canvas = await html2canvas(section, {
          scale: 3,
          useCORS: true,
          logging: false,
          windowWidth: section.scrollWidth,
          windowHeight: section.scrollHeight,
          backgroundColor: "#ffffff",
        });

        section.style.width = originalWidth;

        const imgData = canvas.toDataURL("image/png", 1.0);
        const imgWidth = pageWidth;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        if (i > 0) pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);

      }

      pdf.save("תנאי שימוש פאייכלה.pdf");
    } catch (err) {
      console.error("PDF generation failed:", err);
      alert("אירעה שגיאה ביצירת ה PDF");
    }
  };

  return (
    <div
      ref={containerRef}
      className="card"
      style={{ textAlign: "right", direction: "rtl" }}
    >
      <img
        src="/pycBlueIogo.png"
        alt="logo-pych"
        style={{ height: "100px" }}
      />
      <div
        style={{ margin: "20px 0" }}
        dangerouslySetInnerHTML={{ __html: termsValue }}
      />
      <button className="nextBtn" onClick={handleOK}>
        אישור
      </button>
      <button className="optionsBtn pdfBtn" onClick={handleDownloadPDF}>
        הורד קובץ PDF
      </button>
    </div>
  );
}

export default TermsCard;
